import { useEffect, useMemo } from 'react';

// [USE_DAILY_DECISION]
export function useDailyDecisionShareState(allCrews = [], sharedCrewIds = new Set()) {
  // [DAILY_SHARE_IMMUTABLE_SET]
  // Normalize Set/array inputs to immutable sets for exact overlap checks.

  const crewIds = useMemo(() => {
    return new Set((allCrews || []).map((c) => String(c?.id || '')).filter(Boolean));
  }, [allCrews]);

  const sharedIds = useMemo(() => {
    if (sharedCrewIds instanceof Set) {
      return new Set(Array.from(sharedCrewIds).map(String).filter(Boolean));
    }
    return new Set((sharedCrewIds || []).map(String).filter(Boolean));
  }, [sharedCrewIds]);

  const allShared = useMemo(() => {
    return crewIds.size > 0 && Array.from(crewIds).every((id) => sharedIds.has(id));
  }, [crewIds, sharedIds]);

  const unsharedCrewIds = useMemo(() => {
    return allCrews
      .map((c) => c?.id)
      .filter(Boolean)
      .filter((id) => !sharedIds.has(String(id)));
  }, [allCrews, sharedIds]);

  return { allShared, unsharedCrewIds };
}

export function useDailyDecisionForegroundRefresh(loadDecision, debounceMs = 4000) {
  useEffect(() => {
    let timer = null;
    let lastRefreshAt = 0;

    const scheduleRefresh = (reason) => {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      timer = setTimeout(() => {
        timer = null;
        const now = Date.now();
        if (now - lastRefreshAt < debounceMs) {
          console.log('[daily] refresh_debounced', { reason });
          return;
        }
        lastRefreshAt = now;
        loadDecision({ reason, silent: true });
      }, 250);
    };

    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        scheduleRefresh('visibility');
      }
    };

    const onFocus = () => scheduleRefresh('focus');

    document.addEventListener('visibilitychange', onVisibility);
    window.addEventListener('focus', onFocus);

    return () => {
      if (timer) clearTimeout(timer);
      document.removeEventListener('visibilitychange', onVisibility);
      window.removeEventListener('focus', onFocus);
    };
  }, [loadDecision, debounceMs]);
}
